import { Component, OnInit } from '@angular/core';

import {MatDialog, MatDialogRef, MAT_DIALOG_DATA, Sort} from '@angular/material';
import { ConfirmDeleteComponent } from '../partials/confirm-delete/confirm-delete.component';
import { Router } from '@angular/router';
import { Employee } from '../../model/employee';
import { DBService } from '../../services/db.service';
import { Company } from '../../model/company';
import { AuthenticationService } from '../../services/authentication.service';
import { User } from '../../model/user';

import { HttpClient } from '@angular/common/http';

declare var Materialize: any;

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
  providers: [DBService, AuthenticationService]
})
export class UsersComponent implements OnInit {

  DeleteUser = 'https://us-central1-i-ganhei.cloudfunctions.net/DeleteUser';

  loading: boolean;

  list: Employee[];
  displayList: Employee[];

  searchText: string;
  searchInput: string;

  user: User;

  userCompanyUID: string;

  constructor(public dialog: MatDialog, private router: Router, private dbService: DBService, private authService: AuthenticationService, private http: HttpClient) {
    this.loading = true;
    this.searchText = '';

    if (!this.authService.isAdmin()) {
      this.userCompanyUID = this.authService.getUserCompany();
    }

    this.loadUser();
  }

  private loadUser() {
    this.authService.getCurrentUser().subscribe(currentUser => {
      this.user = new User();

      if (currentUser != null) {
        this.user.uid = currentUser.uid;
        this.user.email = currentUser.email;

        this.loadData();
      }
    });
  }

  private loadData() {
    this.dbService.listWithUIDs<Employee>('/employees')
      .then(list => {
        if (this.userCompanyUID) {
          this.list = list.filter(e => e.companyUID === this.userCompanyUID);
        } else {
          this.list = list;
        }

        this.list.forEach(item => {
          item['hasAccess'] = item.isUser ? 'Sim' : 'Não';
          item['canDelete'] = this.user.email.includes('usuario@iganhei.com') || item.companyUID !== 'I-Ganhei';
        });
        this.onSearchChange(this.searchText);

        this.loadCompanies();
      })
      .catch(error => console.log(error));
  }

  private loadCompanies() {
    this.dbService.listWithUIDs<Company>('companies')
      .then(companies => {
        this.list.forEach(item => {
          const filteredCompanies = companies.filter(c => c.uid === item.companyUID);
          if (filteredCompanies.length > 0) {
            item['companyName'] = filteredCompanies[0].name;
          } else {
            item['companyName'] = 'I-Ganhei';
          }
        });
        this.loading = false;
      });
  }

  onSearchChange(searchValue: string ) {
    this.searchText = searchValue.toLowerCase();

    this.displayList = this.list
      .sort((e1, e2) => e1.name.localeCompare(e2.name))
      .filter(item => item.name.toLowerCase().includes(this.searchText) ||
                      item.email.toLowerCase().includes(this.searchText) ||
                      item.job.toLowerCase().includes(this.searchText) ||
                      item['companyName'].toLowerCase().includes(this.searchText) ||
                      item['hasAccess'].toLowerCase().includes(this.searchText));
  }

  sortData(sort: Sort) {
    if (!sort.active || sort.direction == '') {
      return;
    }

    this.displayList = this.displayList.sort((a, b) => {
      const isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'name': return this.compare(a.name, b.name, isAsc);
        case 'email': return this.compare(a.email, b.email, isAsc);
        case 'job': return this.compare(a.job, b.job, isAsc);
        case 'company': return this.compare(a['companyName'], b['companyName'], isAsc);
        case 'hasAccess': return this.compare(a['hasAccess'], b['hasAccess'], isAsc);
        default: return 0;
      }
    });
  }

  private compare(a, b, isAsc) {
    return a.localeCompare(b) * (isAsc ? 1 : -1);
  }

  ngOnInit() {
  }

  goToNew() {
    this.router.navigate(['usuarios/novo']);
  }

  openDeleteModal(employee: Employee) {
    const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
      height: 'auto',
      width: '600px',
      data: { name: employee.name }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) { this.confirmDelete(employee.uid); }
    });
  }

  private confirmDelete(uid: string) {
    const data = {
      uid: uid,
    }

    this.http.post(this.DeleteUser, data).subscribe();
    this.loading = true;
    this.dbService.remove('/employees', uid)
      .then(() => {
        this.searchInput = "";
        this.dbService.remove('/users', uid);
        Materialize.toast('Usuário removido com sucesso', 2000);
        this.onSearchChange(this.searchInput);
        this.loadData();
      })
      .catch(error => console.log(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/users/users.component.ts